// import { Component, OnInit } from "@angular/core";
// import { Router, ActivatedRoute } from "@angular/router";
// import { NgxSpinnerService } from "ngx-spinner";
// import { ToastrService } from "ngx-toastr";
// import { EnterpriseService } from "../../enterprise.service";
// import { WebSocketService } from "src/app/web-socket.service";

// @Component({
//   selector: "app-track-trip",
//   templateUrl: "./track-trip.component.html",
//   styleUrls: ["./track-trip.component.sass"],
// })
// export class TrackTripComponent implements OnInit {
//   constructor(
//     private router: Router,
//     public activatedRoute: ActivatedRoute,
//     private packageTrackservice: EnterpriseService,
//     private spinner: NgxSpinnerService,
//     private toastr: ToastrService,
//     private websocketService: WebSocketService
//   ) {}

//   greenIcon = "../../assets/images/greenIcon.png";
//   vehicleIcon = "../../assets/images/vehicleIcon.png";
//   redIcon = "../../assets/images/redIcon.png";

//   id: any;
//   tripData: any;
//   status: any;

//   waypoints: any[] = [];

//   directionRenderOptions = {
//     suppressMarkers: true,
//     polylineOptions: {
//       strokeColor: "#0009FF",
//       strokeOpacity: 0.8,
//       strokeWeight: 6,
//     },
//   };

//   mapCenter: { lat: number; lng: number } = { lat: 19.076, lng: 72.8777 };

//   driverLocation: { lat: number; lng: number } = { lat: 0, lng: 0 };
//   previousDriverLocation: { lat: number; lng: number } | null = null;

//   animationInterval: any;
//   animationSteps = 20; // smoothness (higher = smoother)
//   animationDuration = 1000; // ms

//   origin: { lat: number; lng: number } = { lat: 0, lng: 0 };
//   destination: { lat: number; lng: number } = { lat: 0, lng: 0 };

//   // ✅ NEW
//   stopsPath: { lat: number; lng: number }[] = [];
//   stopMarkers: any[] = [];

//   ngOnInit(): void {
//     this.id = this.activatedRoute.snapshot.queryParams.id;
//     // this.websocketService.connect();
//     this.getPackageById();
//     this.socketData();
//   }

//   getPackageById() {
//     this.spinner.show();

//     this.packageTrackservice.getTripByID(this.id).subscribe((result: any) => {
//       this.spinner.hide();

//       if (result.statusCode === 200) {
//         this.tripData = result.data;
//         this.status = this.tripData.status;

//         /** -----------------------------
//          *  BUILD PATH FROM STOPS
//          *  ----------------------------- */
//         const sortedStops = this.tripData.stops.sort(
//           (a: any, b: any) => a.sequence - b.sequence
//         );

//         // Origin & Destination
//         this.origin = {
//           lat: sortedStops[0].latitude,
//           lng: sortedStops[0].longitude,
//         };
//         this.mapCenter = { ...this.origin };

//         this.destination = {
//           lat: sortedStops[sortedStops.length - 1].latitude,
//           lng: sortedStops[sortedStops.length - 1].longitude,
//         };

//         // Origin
//         this.origin = {
//           lat: sortedStops[0].latitude,
//           lng: sortedStops[0].longitude,
//         };

//         // Destination
//         this.destination = {
//           lat: sortedStops[sortedStops.length - 1].latitude,
//           lng: sortedStops[sortedStops.length - 1].longitude,
//         };

//         // Waypoints (middle stops only)
//         this.waypoints = sortedStops
//           .slice(1, sortedStops.length - 1)
//           .map((stop: any) => ({
//             location: { lat: stop.latitude, lng: stop.longitude },
//             stopover: true,
//           }));

//         // Stop Markers
//         this.stopMarkers = sortedStops.map((stop: any, index: number) => ({
//           lat: stop.latitude,
//           lng: stop.longitude,
//           status: stop.status,
//           label: index + 1,
//         }));

//         /** -----------------------------
//          *  STATUS MESSAGES
//          *  ----------------------------- */
//         if (this.status === 1) {
//           this.toastr.success("Trip is generated by user");
//         } else if (this.status === 2) {
//           this.toastr.info("Driver is on the way to pick");
//         } else if (this.status === 3) {
//           this.toastr.success("Driver is on the way to deliever");
//         } else if (this.status === 4) {
//           this.toastr.error("Trip Delivered");
//         } else if (this.status === 5) {
//           this.toastr.error("User cancelled trip");
//         } else if (this.status === 6) {
//           this.toastr.error("Driver cancelled trip");
//         }
//       } else {
//         this.toastr.error(result.message);
//       }
//     });
//   }

//   /** -----------------------------
//    *  DRIVER LIVE LOCATION
//    *  ----------------------------- */
//   socketData() {
//     this.websocketService
//       .onEnterpriseDriverLocationUpdate()
//       .subscribe((result: any) => {
//         if (!this.tripData || result.tripId !== this.tripData._id) return;

//         const newLocation = {
//           lat: result.lat,
//           lng: result.lng,
//         };

//         // First location (no animation)
//         if (!this.previousDriverLocation) {
//           this.driverLocation = newLocation;
//           this.previousDriverLocation = newLocation;
//           return;
//         }

//         // Animate from previous → new
//         this.animateDriverMovement(this.previousDriverLocation, newLocation);

//         this.previousDriverLocation = newLocation;
//       });
//   }

//   /** -----------------------------
//    *  STOP ICON LOGIC
//    *  ----------------------------- */
//   getStopIcon(status: number, index: number) {
//     if (index === 0) return this.greenIcon; // Start
//     if (status === 2) return this.vehicleIcon; // Active stop
//     return this.redIcon; // Pending / completed
//   }

//   animateDriverMovement(
//     from: { lat: number; lng: number },
//     to: { lat: number; lng: number }
//   ) {
//     let step = 0;
//     const latStep = (to.lat - from.lat) / this.animationSteps;
//     const lngStep = (to.lng - from.lng) / this.animationSteps;

//     clearInterval(this.animationInterval);

//     this.animationInterval = setInterval(() => {
//       if (step >= this.animationSteps) {
//         clearInterval(this.animationInterval);
//         this.driverLocation = { ...to };
//         return;
//       }

//       this.driverLocation = {
//         lat: from.lat + latStep * step,
//         lng: from.lng + lngStep * step,
//       };

//       step++;
//     }, this.animationDuration / this.animationSteps);
//   }

//   back() {
//     this.router.navigateByUrl("dashboard/enterprise-trips");
//   }
// }

import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { EnterpriseService } from "../../enterprise.service";
import { WebSocketService } from "src/app/web-socket.service";
import { Subscription } from "rxjs";

declare var google: any;

@Component({
  selector: "app-track-trip",
  templateUrl: "./track-trip.component.html",
  styleUrls: ["./track-trip.component.sass"],
})
export class TrackTripComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private packageTrackservice: EnterpriseService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private websocketService: WebSocketService,
  ) {}

  // ----------------------------
  // Icons
  // ----------------------------

  greenIcon = "../../assets/images/greenIcon.png";
  vehicleIcon = "../../assets/images/vehicleIcon.png";
  redIcon = "../../assets/images/redIcon.png";

  // ----------------------------
  // Basic Data
  // ----------------------------

  id: any;
  tripData: any;
  status = 1;

  socketSubscription!: Subscription;

  // ----------------------------
  // Locations
  // ----------------------------

  mapCenter = {
    lat: 19.076,
    lng: 72.8777,
  };

  origin = {
    lat: 0,
    lng: 0,
  };

  destination = {
    lat: 0,
    lng: 0,
  };

  driverLocation = {
    lat: 0,
    lng: 0,
  };

  previousDriverLocation: any = null;

  // ----------------------------
  // Stops
  // ----------------------------

  stopMarkers: any[] = [];

  sortedStops: any[] = [];

  // ----------------------------
  // Driver Animation
  // ----------------------------

  animationInterval: any;

  animationSteps = 20;

  animationDuration = 1000;

  // ----------------------------
  // Google Maps
  // ----------------------------

  googleMap: any;

  directionsService: any;

  directionsRenderer: any;

  lastRoutePosition: any = null;

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.queryParams.id;

    this.getPackageById();
  }

  ngOnDestroy(): void {
    if (this.socketSubscription) {
      this.socketSubscription.unsubscribe();
    }

    clearInterval(this.animationInterval);
  }

  // ==========================================
  // Map Ready
  // ==========================================

  onMapReady(map: any) {
    this.googleMap = map;

    this.directionsService = new google.maps.DirectionsService();

    this.directionsRenderer = new google.maps.DirectionsRenderer({
      suppressMarkers: true,

      preserveViewport: true,

      polylineOptions: {
        strokeColor: "#0009FF",

        strokeWeight: 6,

        strokeOpacity: 0.8,
      },
    });

    this.directionsRenderer.setMap(this.googleMap);

    if (this.tripData) {
      this.drawRoute();
    }
  }

  // ==========================================
  // Load Trip
  // ==========================================

  getPackageById() {
    this.spinner.show();

    this.packageTrackservice.getTripByID(this.id).subscribe(
      (result: any) => {
        this.spinner.hide();

        if (result.statusCode != 200) {
          this.toastr.error(result.message);

          return;
        }

        this.tripData = result.data;

        this.status = this.tripData.status;

        this.sortedStops = [...this.tripData.stops].sort(
          (a: any, b: any) => a.sequence - b.sequence,
        );

        // -------------------------
        // Origin
        // -------------------------

        this.origin = {
          lat: Number(this.sortedStops[0].latitude),

          lng: Number(this.sortedStops[0].longitude),
        };

        // -------------------------
        // Destination
        // -------------------------

        this.destination = {
          lat: Number(this.sortedStops[this.sortedStops.length - 1].latitude),

          lng: Number(this.sortedStops[this.sortedStops.length - 1].longitude),
        };

        this.mapCenter = {
          ...this.origin,
        };

        // -------------------------
        // Stop Markers
        // -------------------------

        this.stopMarkers = this.sortedStops.map((stop: any, index: number) => ({
          lat: Number(stop.latitude),

          lng: Number(stop.longitude),

          status: stop.status,

          label: index + 1,
        }));

        if (this.googleMap) {
          this.drawRoute();
        }

        this.socketData();
      },

      () => {
        this.spinner.hide();
      },
    );
  }

  // ==========================================
  // Driver Socket
  // ==========================================

  socketData() {
    this.socketSubscription = this.websocketService
      .onEnterpriseDriverLocationUpdate()
      .subscribe((result: any) => {
        if (!this.tripData) return;

        if (result.tripId != this.tripData._id) return;

        const newLocation = {
          lat: Number(result.lat),
          lng: Number(result.lng),
        };

        // First location
        if (!this.previousDriverLocation) {
          this.driverLocation = { ...newLocation };

          this.previousDriverLocation = { ...newLocation };

          this.lastRoutePosition = { ...newLocation };

          if (this.status == 2 || this.status == 3) {
            this.drawRoute();
          }

          return;
        }

        // Smooth marker animation
        this.animateDriverMovement(this.previousDriverLocation, newLocation);

        // Redraw route only after driver moved ~40 meters
        if (this.status == 2 || this.status == 3) {
          const distance = this.distanceBetween(
            this.lastRoutePosition.lat,
            this.lastRoutePosition.lng,
            newLocation.lat,
            newLocation.lng,
          );

          if (distance > 40) {
            this.lastRoutePosition = { ...newLocation };

            this.drawRoute();
          }
        }

        this.previousDriverLocation = { ...newLocation };
      });
  }

  // ==========================================
  // Draw Route
  // ==========================================

  drawRoute() {
    if (!this.googleMap) return;

    let routeOrigin: any;
    let routeDestination: any;
    let routeWaypoints: any[] = [];

    switch (this.status) {
      // =====================================
      // CREATED
      // =====================================

      case 1:
        routeOrigin = this.origin;

        routeDestination = this.destination;

        routeWaypoints = this.sortedStops
          .slice(1, this.sortedStops.length - 1)
          .map((stop) => ({
            location: {
              lat: Number(stop.latitude),
              lng: Number(stop.longitude),
            },
            stopover: true,
          }));

        break;

      // =====================================
      // ACCEPTED
      // Driver -> Stop 1 -> Remaining Stops
      // =====================================

      case 2:
        if (!this.driverLocation.lat) return;

        routeOrigin = this.driverLocation;

        routeDestination = this.destination;

        routeWaypoints = this.sortedStops.map((stop) => ({
          location: {
            lat: Number(stop.latitude),
            lng: Number(stop.longitude),
          },
          stopover: true,
        }));

        break;

      // =====================================
      // ONGOING
      // Driver -> Current Stop -> Remaining Stops
      // =====================================

      case 3:
        if (!this.driverLocation.lat) return;

        routeOrigin = this.driverLocation;

        const currentIndex = this.sortedStops.findIndex(
          (stop) => stop.status == 2,
        );

        if (currentIndex == -1) {
          routeDestination = this.destination;

          routeWaypoints = [];
        } else {
          routeDestination = this.destination;

          routeWaypoints = this.sortedStops.slice(currentIndex).map((stop) => ({
            location: {
              lat: Number(stop.latitude),
              lng: Number(stop.longitude),
            },
            stopover: true,
          }));
        }

        break;

      // =====================================
      // COMPLETED / CANCELLED
      // =====================================

      case 4:
      case 5:
      case 6:
        routeOrigin = this.origin;

        routeDestination = this.destination;

        routeWaypoints = this.sortedStops
          .slice(1, this.sortedStops.length - 1)
          .map((stop) => ({
            location: {
              lat: Number(stop.latitude),
              lng: Number(stop.longitude),
            },
            stopover: true,
          }));

        break;
    }

    this.directionsService.route(
      {
        origin: routeOrigin,

        destination: routeDestination,

        waypoints: routeWaypoints,

        optimizeWaypoints: false,

        travelMode: google.maps.TravelMode.DRIVING,
      },
      (response: any, status: any) => {
        if (status == google.maps.DirectionsStatus.OK) {
          this.directionsRenderer.setDirections(response);
        }
      },
    );
  }

  // ==========================================
  // Smooth Driver Animation
  // ==========================================

  animateDriverMovement(from: any, to: any) {
    clearInterval(this.animationInterval);

    let step = 0;

    const latStep = (to.lat - from.lat) / this.animationSteps;

    const lngStep = (to.lng - from.lng) / this.animationSteps;

    this.animationInterval = setInterval(() => {
      if (step >= this.animationSteps) {
        clearInterval(this.animationInterval);

        this.driverLocation = { ...to };

        return;
      }

      this.driverLocation = {
        lat: from.lat + latStep * step,

        lng: from.lng + lngStep * step,
      };

      step++;
    }, this.animationDuration / this.animationSteps);
  }

  // ==========================================
  // Distance
  // ==========================================

  distanceBetween(lat1: number, lng1: number, lat2: number, lng2: number) {
    if (!lat1 || !lng1) {
      return 999999;
    }

    const R = 6371000;

    const dLat = ((lat2 - lat1) * Math.PI) / 180;

    const dLng = ((lng2 - lng1) * Math.PI) / 180;

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);

    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  // ==========================================
  // Marker Icon
  // ==========================================

  getStopIcon(status: number, index: number) {

  if (index === 0) {
    return this.greenIcon;
  }

  if (status === 2) {
    return this.redIcon; // or redIcon
  }

  return this.redIcon;
}

  back() {
    this.router.navigateByUrl("dashboard/enterprise-trips");
  }
}
